/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useObserver } from "mobx-react-lite";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  useAppInsightsContext,
  useTrackMetric,
} from "@microsoft/applicationinsights-react-js";
import DashboardTabs from "../Dashboard/DashboardTabs";
import NotificationsList from "./NotificationList";
import { useGlobalStore } from "../../state/GlobalStore";
import { AppInsightsConstants } from "../../Constants";
import { AppInsightMethods } from "../../AppInsightMethods";
import PatientList from "./PatientList";

export const NoResult = () => {
  return (
    <Grid className={"noResultStyle"}>
      <InfoOutlinedIcon />
      <span>No Result</span>
    </Grid>
  );
};

export default function NotificationsTab() {
  const pageName = "Notifications";
  const appInsights = useAppInsightsContext();
  const [value, setValue] = useState<string>("All");
  const globalStore = useGlobalStore();
  const [searchText, setSearchText] = useState("");
  const trackComponent = useTrackMetric(appInsights, pageName);

  useEffect(() => {
    trackComponent();
  }, []);

  return useObserver(() => {
    return (
      <Grid>
        <DashboardTabs
          parentTabName={pageName}
          selectedSubTab={value}
          handleTabChange={(e: any, newValue: string) => {
            setValue(newValue);
            AppInsightMethods.trackAppInsightsEvent(
              pageName,
              AppInsightsConstants.Information,
              `The "${newValue}" tab has been clicked on the ${pageName} section.`,
              globalStore.loginUserEmail,
              window.location.href,
              ""
            );
          }}
          searchText={searchText}
          setSearchText={(val: string) => setSearchText(val)}
        />
        {value.includes("All") && <NotificationsList />}
        {value === "Provider" && (
          <Grid className={"dashboard_relaxation_video"}>
            <PatientList selectedSubTabs={value} />
          </Grid>
        )}
        {value === "Patient" && (
          <Grid className={"dashboard_relaxation_video"}>
            <PatientList selectedSubTabs={value} />
          </Grid>
        )}
      </Grid>
    );
  });
}
